import { getManifestI18n } from "./manifestI18n.js";

export const I18N_ROLLOUT_FLAG_KEYS = [
  "clientViewI18nEnabled",
  "localizedRoutesEnabled",
  "localizedSeoEnabled",
  "displayCurrencyEnabled",
  "fxConversionEnabled",
  "studioTranslationEditorEnabled",
  "translationImportEnabled",
  "missingTranslationWarningsEnabled",
];

export const DEFAULT_STRICT_LAUNCH_READINESS = {
  strictTranslations: false,
  strictLocalizedSeo: false,
  strictFxFreshness: false,
  strictNeedsUpdate: false,
};

function readBoolean(value, fallback) {
  if (value == null) return fallback;
  return value !== false;
}

export function buildDefaultI18nRollout(manifestI18n) {
  const bilingual = manifestI18n.supportedLocales.length > 1;
  const multiCurrency = manifestI18n.supportedCurrencies.length > 1;

  return {
    clientViewI18nEnabled: true,
    localizedRoutesEnabled: bilingual,
    localizedSeoEnabled: bilingual,
    displayCurrencyEnabled: multiCurrency,
    fxConversionEnabled: multiCurrency,
    studioTranslationEditorEnabled: true,
    translationImportEnabled: true,
    missingTranslationWarningsEnabled: bilingual,
  };
}

export function normalizeI18nRollout(rawRollout, manifestI18n) {
  const normalizedI18n = manifestI18n || getManifestI18n({});
  const defaults = buildDefaultI18nRollout(normalizedI18n);
  const raw = rawRollout && typeof rawRollout === "object" && !Array.isArray(rawRollout) ? rawRollout : {};

  return {
    clientViewI18nEnabled: readBoolean(raw.clientViewI18nEnabled, defaults.clientViewI18nEnabled),
    localizedRoutesEnabled: readBoolean(raw.localizedRoutesEnabled, defaults.localizedRoutesEnabled),
    localizedSeoEnabled: readBoolean(raw.localizedSeoEnabled, defaults.localizedSeoEnabled),
    displayCurrencyEnabled: readBoolean(raw.displayCurrencyEnabled, defaults.displayCurrencyEnabled),
    fxConversionEnabled: readBoolean(raw.fxConversionEnabled, defaults.fxConversionEnabled),
    studioTranslationEditorEnabled: readBoolean(
      raw.studioTranslationEditorEnabled,
      defaults.studioTranslationEditorEnabled
    ),
    translationImportEnabled: readBoolean(raw.translationImportEnabled, defaults.translationImportEnabled),
    missingTranslationWarningsEnabled: readBoolean(
      raw.missingTranslationWarningsEnabled,
      defaults.missingTranslationWarningsEnabled
    ),
  };
}

export function getI18nRollout(manifest) {
  const manifestI18n = getManifestI18n(manifest);
  return normalizeI18nRollout(manifest?.i18n?.rollout, manifestI18n);
}

export function normalizeLaunchReadiness(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return { ...DEFAULT_STRICT_LAUNCH_READINESS };
  }
  return {
    strictTranslations: raw.strictTranslations === true,
    strictLocalizedSeo: raw.strictLocalizedSeo === true,
    strictFxFreshness: raw.strictFxFreshness === true,
    strictNeedsUpdate: raw.strictNeedsUpdate === true,
  };
}

export function getLaunchReadiness(manifest) {
  return normalizeLaunchReadiness(manifest?.launchReadiness);
}
